import 'lazysizes'
import conditioner, { screen } from '@parallaxagency/conditioner'
import screens from '../../tailwind.screens.js'
import '../js/components/slider'

function main() {
  conditioner.addPlugin({
    moduleSetName: name => `./components/${name}.js`,
    moduleGetConstructor: module => module.default,
    moduleImport: name =>
      import(/* webpackChunkName: 'conditioner' */ `${name}`)
  })
  conditioner.addPlugin(screen(screens))
  conditioner.hydrate(document.documentElement)

  if (process.env.NODE_ENV !== 'production') {
    import(
      /* webpackChunkName: "BrowserGrid" */ '@parallaxagency/browsergrid'
    ).then(({ BrowserGrid }) => {
      // eslint-disable-next-line no-unused-vars
      const browserGrid = new BrowserGrid([
        {
          width: 1800 + 24,
          cols: 16,
          gutter: 12,
          includeCenterLines: 8
        }
      ])
    })
  }
}

function onTouchStart() {
  window.removeEventListener('touchstart', onTouchStart)
  window.True.isTouch = true
}
window.addEventListener('touchstart', onTouchStart)

function loadScript(src, done) {
  let js = document.createElement('script')
  js.src = src
  js.onload = function() {
    done()
  }
  js.onerror = function() {
    done(new Error('Failed to load script ' + src))
  }
  document.head.appendChild(js)
}

// Recent browsers will have all these cool features, so most requests for main.js won't require extra polyfill scripts to be loaded
if (
  window.Promise &&
  window.fetch &&
  window.IntersectionObserver &&
  Array.prototype.includes
) {
  main()
} else {
  loadScript(window.True.polyfills, main)
}



// WEBPACK FOOTER //
// ./src/js/main.js